/**
 * Copyright © 2018 Galaxy Software Services https://github.com/GSS-FED/vital-ui-kit-react
 * MIT license
 */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import React from 'react';
import cn from 'classnames';
import styled, { css } from 'styled-components';
// import { superBoxStyle, BoxProps} from '@vital-ui/react-utils'
import { defaultTheme } from '@vital-ui/react-theme';
import { Badge } from '@vital-ui/react-badge';
var textWidth = function (props) {
    if (props.vertical && props.badge) {
        return 'calc(100% - 40px)';
    }
    if (props.vertical) {
        return '100%';
    }
    return 'auto';
};
var Root = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n  font-size: 1rem;\n  position: relative;\n  z-index: 5;\n  display: ", ";\n  padding: 6px 22px 7px;\n  line-height: 1.3;\n  border-radius: 2.16667rem;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  cursor: pointer;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  margin-left: ", ";\n  margin-right: ", ";\n\n  ", ";\n"], ["\n  background-color: ",
    ";\n  color: ", ";\n  font-size: 1rem;\n  position: relative;\n  z-index: 5;\n  display: ", ";\n  padding: 6px 22px 7px;\n  line-height: 1.3;\n  border-radius: 2.16667rem;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  cursor: pointer;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  margin-left: ", ";\n  margin-right: ", ";\n\n  ",
    ";\n"])), function (_a) {
    var theme = _a.theme, selected = _a.selected;
    return theme.pill.bg(selected);
}, function (_a) {
    var selected = _a.selected, theme = _a.theme;
    return theme.pill.color(selected);
}, function (props) { return (props.vertical ? 'block' : 'inline-block'); }, function (props) { return (props.vertical ? '0' : '10px'); }, function (props) { return (props.vertical ? '0' : '10px'); }, function (_a) {
    var selected = _a.selected, theme = _a.theme;
    return !selected && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      &:hover {\n        background-color: ", ";\n        color: ", ";\n      }\n\n      &:active {\n        background-color: ", ";\n        color: ", ";\n      }\n    "], ["\n      &:hover {\n        background-color: ", ";\n        color: ", ";\n      }\n\n      &:active {\n        background-color: ", ";\n        color: ", ";\n      }\n    "])), theme.pill.hover.bg, theme.pill.hover.color, theme.pill.active.bg, theme.pill.active.color);
});
Root.defaultProps = {
    theme: defaultTheme,
};
var Text = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-block;\n  vertical-align: middle;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-top: -1px;\n  margin-bottom: 1px;\n  width: ", ";\n"], ["\n  display: inline-block;\n  vertical-align: middle;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-top: -1px;\n  margin-bottom: 1px;\n  width: ", ";\n"])), textWidth);
var PillBadge = styled(Badge)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: inline-block;\n  margin: 0 -5px 0 4px;\n  float: right;\n"], ["\n  display: inline-block;\n  margin: 0 -5px 0 4px;\n  float: right;\n"])));
/**
 * @render react
 * @name Pill
 * @description Group of Pills
 * @example
 *       <PillGroup defaultActive={0}>
 *        <Pill label="Dashboard" badge="23" />
 *        <Pill label="Projects" badge="99+" />
 *        <Pill label="Issues" badge="6" />
 *        <Pill label="Reports" />
 *        <Pill label="User Center" />
 *      </PillGroup>
 */
var Pill = /** @class */ (function (_super) {
    __extends(Pill, _super);
    function Pill() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSelect = function () {
            if (_this.props.onSelect) {
                _this.props.onSelect(_this.props.index);
            }
        };
        return _this;
    }
    Pill.prototype.render = function () {
        var _a = this.props, _b = _a.vertical, vertical = _b === void 0 ? false : _b, _c = _a.current, current = _c === void 0 ? false : _c, badge = _a.badge, index = _a.index, style = _a.style, className = _a.className, onSelect = _a.onSelect, children = _a.children, props = __rest(_a, ["vertical", "current", "badge", "index", "style", "className", "onSelect", "children"]);
        return (React.createElement(Root, __assign({ className: cn('vital__pill', className), style: style, vertical: vertical, selected: current, onClick: this.handleSelect }, props),
            React.createElement(Text, { vertical: vertical, badge: badge }, children),
            badge && React.createElement(PillBadge, null, badge)));
    };
    Pill.defaultProps = {
        current: false,
        vertical: false,
    };
    return Pill;
}(React.Component));
export { Pill };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Pill.js.map